import { PlatformDependent } from '@/components/PlatformDependent'

import { UsersViewDDE } from './UsersView.dde'

const UsersView = () => (
  <PlatformDependent dde>
    <UsersViewDDE />
  </PlatformDependent>
)

export default UsersView
